/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportUserResponseItem } from './ImportUserResponseItem';
import {
    ImportUserResponseItemFromJSON,
    ImportUserResponseItemFromJSONTyped,
    ImportUserResponseItemToJSON,
    ImportUserResponseItemToJSONTyped,
} from './ImportUserResponseItem';

/**
 * 
 * @export
 * @interface ImportUserResponse
 */
export interface ImportUserResponse {
    /**
     * 
     * @type {Array<ImportUserResponseItem>}
     * @memberof ImportUserResponse
     */
    results?: Array<ImportUserResponseItem>;
}

/**
 * Check if a given object implements the ImportUserResponse interface.
 */
export function instanceOfImportUserResponse(value: object): value is ImportUserResponse {
    return true;
}

export function ImportUserResponseFromJSON(json: any): ImportUserResponse {
    return ImportUserResponseFromJSONTyped(json, false);
}

export function ImportUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(ImportUserResponseItemFromJSON)),
    };
}

export function ImportUserResponseToJSON(json: any): ImportUserResponse {
    return ImportUserResponseToJSONTyped(json, false);
}

export function ImportUserResponseToJSONTyped(value?: ImportUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'results': value['results'] == null ? undefined : ((value['results'] as Array<any>).map(ImportUserResponseItemToJSON)),
    };
}

